import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";
import {
  STATIC_REFERENCE_DATA_CACHE_TIME,
  STATIC_REFERENCE_DATA_STALE_TIME,
} from "shared/config/queryConstants";

export const useDoorData = () => {
  const {
    isLoading: isDoorDataLoading,
    error: isDoorDataLoadingError,
    data: doorData,
  } = useQuery({
    queryKey: ["doorData"],
    queryFn: async () => {
      const res = await api().gersOptionTemplates({
        filter: {
          where: {
            type: "door",
            disabled: false,
          },
          fields: [
            "id",
            "configuration",
            "type",
            "typeRestriction",
            "name",
            "code",
            "material",
            "description",
            "price",
            "default",
            "exclude",
            "imageId",
            "carrouselImageIds",
            "carouselImageAltTexts",
            "mainImageAltText",
            "crossSoldOptions",
            "groupLabel",
            "minBeamCount",
          ],
        },
      });

      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: STATIC_REFERENCE_DATA_STALE_TIME,
    cacheTime: STATIC_REFERENCE_DATA_CACHE_TIME,
  });

  return { isDoorDataLoading, isDoorDataLoadingError, doorData };
};
